import Event from '../../core/Event';
import SummaryData from '../../../domain/SummaryData';

export default class OrderDetailsReceived extends Event {
    public static type = 'OrderDetailsReceived';

    constructor(public readonly orderDetails: SummaryData) {
        super(OrderDetailsReceived.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderDetailsReceived.ts